import {
  Date,
  DisplayFunction,
  DisplayOrder,
  ExportFunction,
  ExportLabel,
  TableDisplayed,
  TableDisplayedDefault
} from "projects/nter-ui-kit/src/lib/webkit/components/crud-item/crud-item-decorator";
import {displayYYYMMDDJavaLocalDate} from '@ui-kit/utils/static/date-format-utils';

export class MRIReportDataItem {
  @DisplayOrder(1)
  @TableDisplayedDefault
  @ExportLabel("Tenant")
  tenant: string;

  @Date('Date', 'YYYYMMDD')
  @DisplayOrder(2)
  @TableDisplayedDefault
  @DisplayFunction(displayYYYMMDDJavaLocalDate)
  @ExportFunction(displayYYYMMDDJavaLocalDate)
  @ExportLabel("Date (YYYYMMDD)")
  date: string;

  @DisplayOrder(3)
  @TableDisplayedDefault
  @ExportLabel("TenantCode")
  tenantCode: string;

  @DisplayOrder(4)
  @TableDisplayed
  parentCompanyName: string | null;

  @DisplayOrder(5)
  @TableDisplayedDefault
  @ExportLabel("TransactionCode")
  transactionCode: string;

  @DisplayOrder(6)
  @TableDisplayedDefault
  @ExportLabel("TaxTypeCode")
  taxTypeCode: string;

  @DisplayOrder(7)
  @TableDisplayedDefault
  @ExportLabel("Remarks")
  remarks: string;

  @DisplayOrder(8)
  @TableDisplayedDefault
  @ExportLabel("ExclusiveAmount")
  exclusiveAmount: number;

  constructor(obj: any = {}) {
    obj = obj || {};

    this.tenant = obj.tenant;
    this.date = obj.date;
    this.tenantCode = obj.tenantCode;
    this.parentCompanyName = obj.parentCompanyName;
    this.transactionCode = obj.transactionCode;
    this.taxTypeCode = obj.taxTypeCode;
    this.remarks = obj.remarks;
    this.exclusiveAmount = obj.exclusiveAmount;
  }
}

export interface MRIReportRequest {
  month: number;
  year: number,
  parentCompanyNames: string[];
}
